import * as types from './mutations-types'

export default {
  [types.setEntries] (state, entries) {
    state.entries = entries
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/entries/vuex/mutations.js